import type Cue from 'bundles/interactive-transcript/models/Cue';
import type { LanguageCode } from 'bundles/interactive-transcript/types';

class Track {
  declare cues: Array<Cue>;

  declare languageCode: LanguageCode;

  declare url: string;

  declare sourceContent: $TSFixMe;

  declare isLoaded: boolean;

  declare label: string;

  declare error?: unknown;

  constructor(languageCode: LanguageCode, label: string, url: string) {
    this.languageCode = languageCode;
    this.label = label;
    this.url = url;

    this.sourceContent = null;
    this.cues = [];

    this.isLoaded = false;
  }

  getTextTranscript() {
    return this.cues.map((cue) => cue.text).join(' ');
  }
}

export default Track;
